<template>
  <div>
    <div
      v-if="question.image"
      class="flex justify-center items-end rounded-lg overflow-hidden bg-surface-brand-low"
      :class="{ 'bg-transparent': question.isSmileyImage }"
    >
      <RevIllustration
        alt=""
        :height="question.isSmileyImage ? 150 : 372"
        :src="question.image"
        :width="question.isSmileyImage ? 150 : 372"
      />
    </div>
    <div
      class="flex p-24 flex-col gap-20 bg-surface-default-low rounded-t-lg overflow-hidden items-center md:bg-transparent"
    >
      <h3 v-if="question.title" class="heading-2">{{ question.title }}</h3>
      <QuestionsFormItemText v-if="question.showInfo" :info="question.info" />
      <div class="flex flex-col w-full">
        <RevButton
          v-if="question.options[0]"
          :data-qa="question.key"
          fullWidth="always"
          variant="primary"
          @click="
            emit('answer', question.key, question.options[0].value as string)
          "
        >
          {{ question.options[0].label }}
        </RevButton>
        <button
          v-if="question.options[1]"
          class="body-1-bold mt-8 w-full cursor-pointer underline"
          type="button"
          @click="
            emit('answer', question.key, question.options[1].value as string)
          "
        >
          {{ question.options[1].label }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'

import type { RenderQuestion } from '~/scopes/buyback/composables/useFunnelQuestions'

import QuestionsFormItemText from './QuestionsFormItemText.vue'

defineProps<{
  question: RenderQuestion
}>()

const emit = defineEmits<{
  (event: 'answer', key: string, value: string): void
}>()
</script>
